export enum Paths {
  EDUCATOR_RESOURCES = 'resources',
  ABOUT = 'info',
  LANDING = '',
  GAME = 'game',
  TOS = 'terms-of-use',
  PRIVACY = 'privacy-policy',
  DIRECT_NOTICE = 'direct-notice',
}
